import { UNIT_TYPES } from "@constants/units.constant";

export const MAX_ITERATIONS = 200;
export const TOLERANCE_FLOW = 0.0001;
export const TOLERANCE_FRACTION = 0.000001;
export const MAX_TOTAL_CONCENTRATE_RECYCLE = 100;

export const FEED_RECOVERY_TYPES = {
  adjusted: "adj",
  net: "net",
};

export const RECOVERY_TYPE_MAP = { [FEED_RECOVERY_TYPES.net]: 0, [FEED_RECOVERY_TYPES.adjusted]: 1 };

export const PASS_OPTIMIZATION_TYPES = {
  bypass: "bypass",
  split: "split",
  none: "none",
};

export const FLOW_CALCULATOR_RANGES = {
  selfPassConcentrateRecycle: {
    recycleFraction: { hard: { min: 0.01, max: 97.5 }, soft: { min: 0.01, max: 90 } },
  },
  otherPassConcentrateRecycle: {
    recycleFraction: { hard: { min: 0.01, max: 100 } },
  },
  passOptimization: {
    bypassFraction: { hard: { min: 0, max: 95 } },
    splitFraction: { hard: { min: 0, max: 95 } },
  },
  feedAndRecovery: {
    recovery: { hard: { min: 1, max: 95 }, soft: { min: 1, max: 90 } },
  },
};

export const RO_FLOW_TAGS = {
  adjustedFeed: 4,
  netFeed: 5,
  permeateFlow: 8,
  concentrateFlow: 9,
  waste: 10,
  concentrateRecycleFlow: 11,
  splitFlow: 12,
  bypassFlow: 13,
  concentrateRecycleFromPass2: 14,
  concentrateRecycleFromPass3: 15,
  concentrateRecycleToErd: 18,
  totalPermeate: 20, // bypass of same pass or split of previous pass
};

export const FLOW_CALCULATOR_UNIT_KEY_MAPPING = {
  feedFlow: UNIT_TYPES.FLOW,
  adjustedFeedFlow: UNIT_TYPES.FLOW,
  netFeedFlow: UNIT_TYPES.FLOW,
  optimizationFlow: UNIT_TYPES.FLOW,
  permeateFlow: UNIT_TYPES.FLOW,
  concentrateFlow: UNIT_TYPES.FLOW,
  recycleFlow: UNIT_TYPES.FLOW,
  flux: UNIT_TYPES.FLUX,
};
